import type {ConnectElementConfig} from '../ConnectElementList';

export const TreasuryEntryConfig: ConnectElementConfig = {
  Component: () =>
    import(
      /* webpackChunkName: "TreasuryEntry" */
      '../../../components/MoneyManagement/TreasuryEntry/TreasuryEntry'
    ),
  releaseState: 'internal',
  sentryTeam: 'platform_surfaces_embedded',
  teamOwner: 'platform-surfaces',
  description: 'Modal to onboard users to new Treasury and Issuing Features',
  friendlyName: 'Treasury Entry',
};
